import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function UvodUPravoEvropskihIntegracija() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Uvod u pravo Evropskih integracija" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">
                Uvod u pravo Evropskih integracija
              </h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Uvod u pravo Evropskih
                integracija
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet Uvod u pravo Evropskih integracija će studentima pružiti
                razumijevanja prava i integracija Evropske Unije, njene
                organizacije, nadležnosti organa, pravnih akata koje donosi EU,
                odnosi između tih institucija kao i druga važna pitanja
                djelovanja pravnog i ekonomskog sistema Evropske Unije. Ovaj
                predmet je osnova za dalje izučavanje nekih važnih sadržaja
                tokom studija na ovom Fakultetu, kojima će se Evropska unija kao
                najvažnije pitanje i cilj moderne Crne Gore dublje izučavati a
                sve u cilju bržeg i kvalitetnijeg razvoja. U okviru predavanja
                će osim teoretskih osnova biti izvedene i određene vježbe kojima
                će studentima biti omogućeno bolje razumijevanje nekih važnih
                aspekata praktičnog organizacionog djelovanja sistema javne
                uprave na centralnom nivou kao i na nivou lokalne samouprave.
                Takođe, studenti će se upoznati sa dosadašnjim procesom
                evropskih integracija kao i sa izazovima koji nas očekuju u
                budućnosti.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Očekuje se da studenti nakon uspješno savladanog predmeta Uvod u
                pravo Evropskih integracija mogu da objasne prirodu i proces EU,
                osnovne karakteristike prava Evropske unije, opišu i analiziraju
                rad institucija Evropske unije, pravilno protumače i objasne
                pravo Evropske unije. Takođe, značaj izučavanja predmeta Uvod u
                pravo Evropskih integracija potiče iz potrebe poznavanja
                osnovnih pojmovnih kategorija o organima Evropske unije kao
                najvećeg trgovinskog i ekonomskog bloka na globalnom nivou.
                Pravo Evropske unije sadrži pravna rješenja koja održavaju
                zajedničke interese aktuelnih država članica Evropske unije.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Pojam evropskog prava; Pravo EU kao evropsko pravo u užem
                smislu; Nastanak i razvitak evropskog prava; Teorije o evropskoj
                integraciji; Hronologija integracije; Pravni status Evropske
                unije; Vrijednosti i ciljevi Evropske unije; Pravna priroda
                Evropske unije; Institucije Evropske unije (Komisija, Savjet
                ministara, Evropski savjet, Parlament); Politički i pravosudni
                organi Evropske unije; Opšta obeležja prava Evropske unije;
                Izvršenje i zaštita prava Evropske unije; Perspektive evropskog
                prava.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: Predavanja, vježbe,
                konsultacije, pismene provjere znanja (kolokvijumi),
                individualni rad studenata (seminarski i domaći radovi, referati
                i sl.) kao i grupno učestvovanje studenata na savladavanju
                određenih tematskih jedinica.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P</td>
                    <td>
                      Pojam evropskog prava; Višeznačnost izraza evropsko pravo
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P</td>
                    <td>Pravo EU kao evropsko pravo u užem smislu</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P</td>
                    <td>Nastanak i razvitak evropskog prava</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P</td>
                    <td>Teorije o evropskoj integraciji</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P</td>
                    <td>Hronologija integracije</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P</td>
                    <td>Ustanovljenja i pravni status Evropske unije</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P</td>
                    <td>Vrijednosti i ciljevi Evropske unije</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P</td>
                    <td>Pravna priroda Evropske unije</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P</td>
                    <td>
                      Institucije u Evropskoj uniji; Komisija, Evropski savjet,
                      Savjet ministara, Parlament
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P</td>
                    <td>Politički i pravosudni organi Evropske unije</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P</td>
                    <td>Opšta obeležja prava Evropske unije</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P</td>
                    <td>
                      Izvršenje i zaštita prava Evropske unije; Perspektive
                      evropskog prava
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P</td>
                    <td>
                      Politika proširenja; Pregovori o pristupanju Crne Gore
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 3 č / 2.25h</td>
                            <td>Ukupno: 60 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.25h</td>
                            <td>Nastava + završni ispit: 45 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe:</td>
                            <td>Priprema i ovjera semestra: 4 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 11 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UvodUPravoEvropskihIntegracija;
